<template>
  <div
    class="account-balance-section"
    :class="{ 'account-balance-section--loading': loading }"
  >
    <AccountStatusCard :account="account" :loading="loading" />

    <div
      class="account-balance-widget"
      :class="{
        'account-balance-widget--first-stop': panel === 'firstStop',
        'account-balance-widget--purchases-panel': panel === 'purchases',
      }"
    >
      <button
        type="button"
        class="account-balance-widget__toggle"
        :aria-label="toggleAriaLabel"
        :title="toggleAriaLabel"
        @click="togglePanel"
      >
        <i class="fas fa-exchange-alt" aria-hidden="true" />
      </button>

      <div v-if="loading" class="account-balance-widget__loader">
        <Loader :show="true" />
      </div>
      <template v-else>
        <PurchaseSummaryCard
          v-if="panel === 'purchases'"
          :purchases="account.purchases"
          :purchases-year="account.purchasesYear"
        />
        <FirstStopAccountCard v-else :account="account" />
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from "vue";
import { useI18n } from "vue-i18n";

import AccountStatusCard from "@/components/PortalHome/AccountStatusCard.vue";
import FirstStopAccountCard from "@/components/PortalHome/FirstStopAccountCard.vue";
import PurchaseSummaryCard from "@/components/PortalHome/PurchaseSummaryCard.vue";
import Loader from "@/components/General/Loader/index.vue";

defineProps({
  account: { type: Object, required: true },
  loading: { type: Boolean, default: false },
});

const { t } = useI18n();

const panel = ref("purchases");

function togglePanel() {
  panel.value = panel.value === "purchases" ? "firstStop" : "purchases";
}

const toggleAriaLabel = computed(() =>
  panel.value === "purchases"
    ? t("portalHome.account.toggleToFirstStop")
    : t("portalHome.account.toggleToPurchases")
);
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/account-balance-section";
</style>
